import AdminPreferredNurseTable from 'components/AdminPreferredNurseTable'
import AdminPracticeDetailContext from 'pages/AdminPracticeDetail/context'
import React from 'react'

const AdminPracticePreferredNurses: React.FC = () => {
  const {
    preferredNursesSearchForm,
    preferredNursesSelection,
    preferredNursesColumnVisibilityModel,
    preferredNursesSortModel,
    updatePreferredNursesSearchForm,
    setPreferredNursesSelection,
    setPreferredNursesColumnVisibilityModel,
    setPreferredNursesSortModel,
  } = React.useContext(AdminPracticeDetailContext)
  
  return (
    <AdminPreferredNurseTable
      form={preferredNursesSearchForm}
      updateForm={updatePreferredNursesSearchForm}
      selection={preferredNursesSelection}
      setSelection={setPreferredNursesSelection}
      columnVisibilityModel={preferredNursesColumnVisibilityModel}
      setColumnVisibilityModel={setPreferredNursesColumnVisibilityModel}
      sortModel={preferredNursesSortModel}
      setSortModel={setPreferredNursesSortModel}
    />
  )
}

export default AdminPracticePreferredNurses